interface VirtualTourProps {
    virtualTourData: {
        virtualTourCasagest: string[];
        virtualTourExternal: string[];
    };
}

const VirtualTour: React.FC<VirtualTourProps> = ({ virtualTourData }) => {
    return (
        <div className="virtual-tour-container">
            {/* Virtual Tour Casagest */}
            {virtualTourData.virtualTourCasagest && virtualTourData.virtualTourCasagest.length > 0 && (
                virtualTourData.virtualTourCasagest.map((link, index) => (
                    <iframe key={index} src={link} name="casagest24" allowFullScreen></iframe>
                ))
            )}
            {/* Virtual Tour External */}
            {virtualTourData.virtualTourExternal && virtualTourData.virtualTourExternal.length > 0 && (
                virtualTourData.virtualTourExternal.map((link, index) => (
                    <iframe key={index} src={link} name="externalTour" allowFullScreen></iframe>
                ))
            )}
        </div>
    );
};

export default VirtualTour;